import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

export type ModuleKey = 'accounting' | 'tesorería' | 'budget' | 'vault' | 'maestros' | 'invoicing';

const ROUTE_STORAGE_KEY = 'nebula:activeRoute:';

@Injectable({ providedIn: 'root' })
export class RouteSyncService {
  private readonly router = inject(Router);

  saveRoute(module: ModuleKey, route: string): void {
    const cleanRoute = this._cleanRoute(route);
    localStorage.setItem(`${ROUTE_STORAGE_KEY}${module}`, cleanRoute);
  }

  getRoute(module: ModuleKey): string | null {
    return localStorage.getItem(`${ROUTE_STORAGE_KEY}${module}`);
  }

  clearRoute(module: ModuleKey): void {
    localStorage.removeItem(`${ROUTE_STORAGE_KEY}${module}`);
  }

  clearAllRoutes(): void {
    const modules: ModuleKey[] = [
      'accounting',
      'tesorería',
      'budget',
      'vault',
      'maestros',
      'invoicing',
    ];
    modules.forEach((module) => {
      localStorage.removeItem(`${ROUTE_STORAGE_KEY}${module}`);
    });
  }

  getCurrentRoute(): string {
    return this._cleanRoute(this.router.url);
  }

  normalizeRoute(route: string): string {
    return this._cleanRoute(route)
      .toLowerCase()
      .replace(/tesoreria/g, 'tesorería');
  }

  private _cleanRoute(route: string): string {
    return route.split('?')[0].split('#')[0].replace(/\/+/g, '/').replace(/\/$/, '') || '/';
  }
}
